import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/userIcon.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-49da2cfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hightText" }, "Six", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sign" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_5 = { class: "mobile_header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hightText" }, "Six", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sign" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))

import AIDemoVue from "@/views/AIDemo.vue";
import { store } from "@/utils/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'AIHeader',
  setup(__props) {

const handleOpen = () => {
  store.handleOpenAiModal();
};
const handleClose = () => {
  store.handleCloseAiModal();
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3,
          _createTextVNode("liv ")
        ]),
        _: 1
      }),
      _createElementVNode("div", { class: "login" }, [
        _createElementVNode("div", {
          onClick: handleOpen,
          class: "sign hightText"
        }, "Try it!"),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo"
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _hoisted_7,
          _createTextVNode("liv ")
        ]),
        _: 1
      }),
      _createElementVNode("div", { class: "login" }, [
        _createElementVNode("div", {
          onClick: handleOpen,
          class: "mobile_sign hightText"
        }, "Try it!"),
        _hoisted_8
      ])
    ]),
    _createVNode(AIDemoVue, {
      visible: _unref(store).aiVisible,
      "handle-close": handleClose
    }, null, 8, ["visible"])
  ], 64))
}
}

})